class Processes {
  static getByDeviceId(processes, deviceId) {
    return processes.filter(process => process.deviceId === deviceId)
  }
}

export default Processes
